import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarHistorialAutorizaciones } from "../services/historial-service";

/**
 * Historial · stale time corto (10s) porque cambia tras cada autorización
 * del propio usuario, pero no requiere polling agresivo.
 *
 * Filtros de columna y paginado van al server como query params y forman
 * parte del queryKey. `useQuery` + `keepPreviousData` (en vez de
 * `useSuspenseQuery`) para que al filtrar/paginar NO re-suspenda y parpadee.
 */

/** Tamaño de página compartido entre la page y el loader del route (misma queryKey). */
export const HISTORIAL_PAGE_SIZE = 15;

export const historialAutorizacionesQueryOptions = (
  params: Record<string, string | number> = { page: 1, pageSize: HISTORIAL_PAGE_SIZE },
) =>
  queryOptions({
    queryKey: [...qk.historialAutorizaciones, params] as const,
    queryFn: () => listarHistorialAutorizaciones(params),
    staleTime: 10_000,
    placeholderData: keepPreviousData,
  });

export const useHistorialAutorizaciones = (
  params: Record<string, string | number> = { page: 1, pageSize: HISTORIAL_PAGE_SIZE },
) => useQuery(historialAutorizacionesQueryOptions(params));
